$size-xxs: 14px;
$size-xs: 16px;
$size-s: 18px;
$size-m: 20px;
$size-l: 22px;
$size-xl: 24px;

[data-fpsm-theme='oddschecker'],
[data-fpsm-theme='plus'],
[data-fpsm-theme='whoscored'],
[data-fpsm-theme='gazzetta'] {
  --badge-error-background: initial;
}

[data-fpsm-theme='plus'] {
  --badge-error-background: #ff4365;
}

[data-fpsm-theme='gazzetta'] {
  --badge-error-background: #d60000;
}

.badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--cxy-spacing-xxxsm);
  width: max-content;
  padding-inline: var(--cxy-spacing-xxsm);
  font-family: var(--cxy-font-family-sans);
}

.primary {
  background-color: var(--cxy-color-tag);
  color: var(--cxy-color-content-contrast);
  border-radius: var(--cxy-border-radius-s);
}

.secondary {
  background-color: var(--cxy-color-surface-primary-default-subtle);
  color: var(--cxy-color-text-default-body);
  border-radius: var(--cxy-border-radius-xs);
}

.error {
  background-color: var(--badge-error-background, var(--cxy-color-error));
  color: var(--cxy-color-text-default-body);
  border-radius: var(--cxy-border-radius-s);
}

.size-xs {
  font-size: var(--cxy-fontSize-xxs);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: var(--cxy-lineHeight-xxs);

  height: $size-xxs;
  min-width: $size-xxs;

  &.isRound {
    height: $size-xs;
    min-width: $size-xs;
  }
}

.size-s {
  font-size: var(--cxy-fontSize-xxs);
  font-weight: var(--cxy-fontWeight-medium);
  line-height: var(--cxy-lineHeight-xs);

  height: $size-xs;
  min-width: $size-xs;

  &.isRound {
    height: $size-s;
    min-width: $size-s;
  }
}

.size-m {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xxs);

  height: $size-m;
  min-width: $size-m;

  &.isRound {
    font-size: var(--cxy-fontSize-s);
    font-weight: var(--cxy-fontWeight-semiBold);

    height: $size-l;
    min-width: $size-l;
  }
}

.size-l {
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-bold);
  line-height: var(--cxy-lineHeight-xxs);

  height: $size-l;
  min-width: $size-l;

  &.isRound {
    font-size: var(--cxy-fontSize-s);
    font-weight: var(--cxy-fontWeight-semiBold);

    height: $size-xl;
    min-width: $size-xl;
  }
}

.isRound {
  border-radius: 100%;
  padding: 0;
}
